/** Component page that displays the login details for the user to login to the demo site.
 */
import React from 'react';
import { Button, Card } from 'react-bootstrap';
import StageManager from '../../services/stageManager';
import Header from '../header/Header';

export default class LiveSite extends React.Component {
    constructor() {
        super();
        this.stageMan = new StageManager();
        this.state = {
            liveurl: 'https://m365x123456.sharepoint.com/'
        };
    }

    /** TODO wire this up correctly */
    _copyToClipboard(element) {
        let copyText = document.getElementById(element);
        copyText.select();
        document.execCommand("copy");
    }

    render() {
        let stageObj = this.stageMan.getStageByIndex(this.props.location.state.stage);
        let descText = stageObj[this.props.location.state.type].desc;
        return (
            <div>
                <Header history={this.props.history} />
                <div className={"pageContainer"}>
                    <br />
                    <Card>
                        <Card.Body>
                            <Card.Title>Live Site Details</Card.Title>
                            <Card.Text>
                                <p>{descText}</p>
                                <p style={{ margin: "auto", width: "100%", textAlign: "center" }}>{this.state.liveurl}</p>
                                <Button href={this.state.liveurl} target={"_blank"}>Go To Site</Button>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/LiveSite.js